module.exports = {"622901001":"城南街道","622901002":"城北街道","622901003":"东关街道","622901004":"西关街道","622901005":"八坊街道","622901006":"红园街道","622901007":"东区街道","622901100":"城郊镇","622901101":"枹罕镇","622901102":"南龙镇","622901103":"折桥镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/622901.json
// module id = 3102
// module chunks = 0